import { render, staticRenderFns } from "./DomainDialog.vue?vue&type=template&id=368edc31&scoped=true"
import script from "./DomainDialog.vue?vue&type=script&lang=ts"
export * from "./DomainDialog.vue?vue&type=script&lang=ts"
import style0 from "./DomainDialog.vue?vue&type=style&index=0&id=368edc31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368edc31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
